/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const OttoLinkIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M3.18838 4.83008C3.52919 4.83008 3.80547 5.09702 3.80547 5.4263V8.31124L9.83395 12.0557L15.8624 8.31124V5.4263C15.8624 5.09702 16.1387 4.83008 16.4795 4.83008C16.8203 4.83008 17.0966 5.09702 17.0966 5.4263V8.38635C17.0966 8.74529 16.9077 9.07959 16.5952 9.27368L10.4243 13.1066C10.0647 13.3299 9.6032 13.3299 9.24356 13.1066L3.07268 9.27368C2.76019 9.07959 2.57129 8.74529 2.57129 8.38635V5.4263C2.57129 5.09702 2.84757 4.83008 3.18838 4.83008Z"
      fill="#334155"
    />
    <path
      d="M3.18838 11.251C3.52919 11.251 3.80547 11.5179 3.80547 11.8472V13.7944L9.84423 17.1284L16.3371 13.7826V11.8472C16.3371 11.5179 16.6134 11.251 16.9542 11.251C17.295 11.251 17.5713 11.5179 17.5713 11.8472V13.8652C17.5713 14.2548 17.3491 14.6126 16.9933 14.7959L10.3556 18.2163C10.0246 18.3869 9.62599 18.3813 9.30019 18.2015L3.12139 14.7901C2.78122 14.6023 2.57129 14.2528 2.57129 13.8742V11.8472C2.57129 11.5179 2.84757 11.251 3.18838 11.251Z"
      fill="#334155"
    />
    <path
      d="M4.67632 11.909C4.88089 11.6456 5.2677 11.5923 5.54028 11.79L6.90917 12.7826C7.18175 12.9802 7.23689 13.354 7.03232 13.6173C6.82775 13.8807 6.44094 13.934 6.16836 13.7363L4.79948 12.7437C4.52689 12.5461 4.47175 12.1724 4.67632 11.909Z"
      fill="#334155"
    />
    <path
      d="M15.0942 11.9751C15.2833 12.2491 15.2067 12.6193 14.9231 12.8019L13.499 13.7192C13.2155 13.9018 12.8323 13.8278 12.6433 13.5538C12.4542 13.2798 12.5309 12.9097 12.8144 12.727L14.2385 11.8097C14.5221 11.6271 14.9052 11.7011 15.0942 11.9751Z"
      fill="#334155"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.3146 1.45968C10.0108 1.31292 9.65321 1.31292 9.34942 1.45968L6.06525 3.04624C5.69968 3.22285 5.46875 3.58387 5.46875 3.97877V7.07381C5.46875 7.43328 5.66042 7.76741 5.97592 7.95793L9.26008 9.94113C9.61 10.1524 10.054 10.1524 10.4039 9.94113L13.6881 7.95793C14.0036 7.76741 14.1952 7.43328 14.1952 7.07381V3.97877C14.1952 3.58387 13.9643 3.22285 13.5987 3.04624L10.3146 1.45968ZM10.4678 8.18359V6.36133H12.29C12.6428 6.36133 12.9287 6.07539 12.9287 5.72266C12.9287 5.36993 12.6428 5.08398 12.29 5.08398H10.4678V3.26758C10.4678 2.91809 10.1845 2.63477 9.83496 2.63477C9.48547 2.63477 9.20215 2.91809 9.20215 3.26758V5.08398H7.37402C7.02129 5.08398 6.73535 5.36993 6.73535 5.72266C6.73535 6.07539 7.02129 6.36133 7.37402 6.36133H9.20215V8.18359C9.20215 8.53309 9.48547 8.81641 9.83496 8.81641C10.1845 8.81641 10.4678 8.53309 10.4678 8.18359Z"
      fill="#334155"
    />
  </svg>
);
export default OttoLinkIcon;
